import React from "react";
import "./FacilityPerformance.less";
import GaugeChart from "react-gauge-chart";

class FacilityPerformanceGaugeChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
   
    return (
        < >
        <GaugeChart
          id={"gauge-chart3"}
          nrOfLevels={30}
          colors={["#FF5F6D", "#FFC371"]}
          arcWidth={0.3}
          percent={0.0}
          textColor={"#2b638d"}
          needleColor={"#2b638d"}
        />
        </>
    );
  }
}
export default FacilityPerformanceGaugeChart;
